const DRIVER_RIDE_STORAGE_KEY = "driver_ride";
const PASSENGER_RIDE_STORAGE_KEY = "passenger_ride";
/**
 * Get data from localStorage
 */
export const getDriverRideDataFromStorage = () => {
    try {
        const data = localStorage.getItem(DRIVER_RIDE_STORAGE_KEY);
        return data ? JSON.parse(data) : {};
    } catch (error) {
        console.error("Error getting driver localStorage data:", error);
        return {};
    }
};

/**
 * Set data in localStorage
 * - If existing data exists, it merges (spreads) old + new object
 */
export const setDriverRideDataInStorage = (newValue) => {
    try {
        const existingData = getDriverRideDataFromStorage();

        const updatedData = {
            ...existingData,
            ...newValue,
        };

        localStorage.setItem(DRIVER_RIDE_STORAGE_KEY, JSON.stringify(updatedData));

        return updatedData;
    } catch (error) {
        console.error("Error setting driver localStorage data:", error);
    }
};

// Clear only "ride" data from localStorage

export const clearDriverRideData = () => {
    try {
        localStorage.removeItem(DRIVER_RIDE_STORAGE_KEY);
    } catch (error) {
        console.error("Error clearing driver localStorage data:", error);
    }
};


/**
 * Get data from localStorage
 */
export const getPassengerRideDataFromStorage = () => {
    try {
        const data = localStorage.getItem(PASSENGER_RIDE_STORAGE_KEY);
        return data ? JSON.parse(data) : {};
    } catch (error) {
        console.error("Error getting driver localStorage data:", error);
        return {};
    }
};

/**
 * Set data in localStorage
 * - If existing data exists, it merges (spreads) old + new object
 */
export const setPassengerRideDataInStorage = (newValue) => {
    try {
        const existingData = getPassengerRideDataFromStorage();

        const updatedData = {
            ...existingData,
            ...newValue,
        };

        localStorage.setItem(PASSENGER_RIDE_STORAGE_KEY, JSON.stringify(updatedData));

        return updatedData;
    } catch (error) {
        console.error("Error setting driver localStorage data:", error);
    }
};

// Clear only "ride" data from localStorage

export const clearPassengerRideData = () => {
    try {
        localStorage.removeItem(PASSENGER_RIDE_STORAGE_KEY);
    } catch (error) {
        console.error("Error clearing driver localStorage data:", error);
    }
};